import {listNhomThuoc, listTTPhieuKho, listTT_ThuocKho} from "data/list";
import moment from "moment";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {ColumnsEdit} from "types/models/column-table-edit";
const {INPUT, CURRENCY, DATE, NUMBER, COMBO_BOX, BUTTON, AUTO_COMPLETE, ICON} =
  FIELD_TYPE;
const inputFields: any[] = [
  {
    type: INPUT,
    label: "Mã phiếu",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tiêu đề phiếu",
    name: "tieuDe",
  },
  {
    type: COMBO_BOX,
    label: "Kho kiểm kê",
    name: "khoId",
    // rules: [{required: true, message: "Chưa chọn kho kiểm kê"}],
    disable: true,
  },
  {
    type: INPUT,
    label: "Người lập phiếu",
    name: "createBy",
    value: localStorage.getItem("fullName"),
    rules: [{required: true, message: "Chưa nhập người lập phiếu"}],
  },
  {
    type: INPUT,
    label: "Người kiểm kê",
    name: "nguoiKiemKe",
  },
  {
    type: DATE,
    label: "Thời điểm kiểm kê",
    name: "createDate",
    optionsTime: {showTime: true, format: FORMAT_TIME.dateTime},
  },
  {
    type: CURRENCY,
    label: "Tổng giá trị",
    name: "tongGiaTri",
  },
  {
    type: INPUT,
    label: "Ghi chú",
    name: "ghiChu",
  },
  {
    type: COMBO_BOX,
    label: "Trạng thái",
    name: "tinhTrang",
    options: listTTPhieuKho,
    disable: true,
  },
];
const columns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: 80,
    show: true,
    align: "center",
  },
  {
    type: INPUT,
    dataIndex: "id",
    align: "center",
    key: "id",
    title: "id",
    // show: true,
    disabled: true,
    width: 0,
  },
  {
    type: INPUT,
    dataIndex: "phieuKiemKeId",
    key: "phieuKiemKeId",
    title: "Phiếu kiểm kê id",
    align: "center",
    // show: false,
    width: 0,
    // disabled: true,
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "thuocId",
    key: "thuocId",
    title: "Mã sản phẩm",
    align: "center",
    show: true,
    autoFocus: true,
    disabled: true,
    width: 200,
  },
  {
    type: AUTO_COMPLETE,
    dataIndex: "soLo",
    key: "soLo",
    title: "Số lô",
    align: "left",
    show: true,
    disabled: true,
    width: 250,
  },

  {
    type: AUTO_COMPLETE,
    dataIndex: "tenThuoc",
    key: "tenThuoc",
    title: "Tên thuốc",
    show: true,
    disabled: true,
    width: 200,
  },
  {
    type: COMBO_BOX,
    dataIndex: "donViTinhId",
    key: "donViTinhId",
    title: "Đơn vị tính",
    show: true,
    disabled: true,
    width: 150,
  },
  {
    type: COMBO_BOX,
    dataIndex: "nguonThuoc",
    key: "nguonThuoc",
    title: "Nguồn thuốc",
    show: true,
    disabled: true,
    width: 200,
  },
  {
    type: INPUT,
    dataIndex: "duocChinh",
    key: "duocChinh",
    title: "Dược chính",
    show: true,
    disabled: true,
  },
  {
    type: COMBO_BOX,
    dataIndex: "tinhTrang",
    key: "tinhTrang",
    title: "Tình trạng",
    options: listTT_ThuocKho,
    show: true,
    width: 200,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "hoatChat",
    key: "hoatChat",
    title: "Hoạt chất",
    show: true,
  },
  {
    type: INPUT,
    dataIndex: "hamLuong",
    key: "hamLuong",
    title: "Hàm lượng",
    show: true,
  },
  {
    type: INPUT,
    dataIndex: "baoChe",
    key: "baoChe",
    title: "Dạng bào chế",
    show: true,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongTonPM",
    key: "soLuongTonPM",
    title: "Số lượng tồn PM",
    align: "right",
    show: true,
  },
  {
    type: BUTTON,
    dataIndex: "fill",
    key: "fill",
    title: "Fill",
    align: "center",
    show: true,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongThuc",
    key: "soLuongThuc",
    title: "Số lượng tồn thực",
    align: "right",
    show: true,
  },
  {
    type: NUMBER,
    dataIndex: "soLuongChenhLech",
    key: "soLuongChenhLech",
    title: "Số lượng chênh lệch",
    align: "right",
    show: true,
  },
  {
    type: CURRENCY,
    dataIndex: "donGiaNhap",
    key: "donGiaNhap",
    title: "Đơn giá nhập",
    align: "right",
    show: true,
    disabled: true,
  },
  {
    type: CURRENCY,
    dataIndex: "giaTriHang",
    key: "giaTriHang",
    title: "Giá trị hàng",
    align: "right",
    show: true,
  },
  {
    type: NUMBER,
    dataIndex: "vat",
    key: "vat",
    title: "VAT(%)",
    align: "right",
    show: true,
    // disabled: true,
  },
  {
    type: CURRENCY,
    dataIndex: "donGiaXuat",
    key: "donGiaXuat",
    title: "Đơn giá xuất",
    align: "right",
    show: true,
    disabled: true,
  },
  {
    type: DATE,
    dataIndex: "ngayNhap",
    key: "ngayNhap",
    title: "Ngày nhập",
    align: "center",
    show: true,
    disabled: true,
  },
  {
    type: DATE,
    dataIndex: "ngaySanXuat",
    key: "ngaySanXuat",
    title: "Ngày sản xuất",
    align: "center",
    show: true,
    disabled: true,
  },
  {
    type: DATE,
    dataIndex: "ngayHetHan",
    key: "ngayHetHan",
    title: "Ngày hết hạn",
    align: "center",
    show: true,
    disabled: true,
  },

  {
    type: INPUT,
    dataIndex: "baoQuan",
    key: "baoQuan",
    title: "Điều kiện bảo quản",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "nhaCungCap",
    key: "nhaCungCap",
    title: "Nhà cung cấp",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "hangSX",
    key: "hangSX",
    title: "Hãng sản xuất",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "soDK",
    key: "soDK",
    title: "Số đăng kí",
    align: "center",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "soLoNcc",
    key: "soLoNcc",
    title: "Số lô của NCC",
    align: "left",
    show: true,
    disabled: true,
  },
  {
    type: INPUT,
    dataIndex: "ghiChu",
    key: "ghiChu",
    title: "Ghi chú",
    show: true,
  },

  // {
  //   title: "",
  //   dataIndex: "",
  //   key: "action",
  //   align: "center",
  //   width: 60,
  //   fixed: "right" as any,
  //   show: true,
  // },
];
export {inputFields, columns};
